export var FormActions = {
    INIT: 0,
    VALIDATE: 1,
    DID_VALIDATE: 2,
    FILE_ADDED: 3
};

export var FormStates = {
    UNDEFINED: -1,
    INITIALIZED: 0,
    WILL_VALIDATE: 1,
    VALIDATED: 2,
    FILE_ADDED: 3
};

export var FormReducer = function FormReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments[1];


    switch (action.type) {
        case FormActions.INIT:
            return { state: FormStates.INITIALIZED };

        case FormActions.VALIDATE:
            return { state: FormStates.WILL_VALIDATE };

        case FormActions.DID_VALIDATE:
            return { state: FormStates.DID_VALIDATE };

        case FormActions.FILE_ADDED:
            return { sate: FormStates.FILE_ADDED };

        default:
            return { state: FormStates.UNDEFINED };

    }
};